import { napoliBari } from "./napoli-bari";
import { palermoCataniaMessina } from "./palermo-catania-messina";
import { pontePo } from "./ponte-po";

export const mediumLevels = [napoliBari, palermoCataniaMessina, pontePo];
